export default __webpack_public_path__ + "static/media/cp_geo_bq.082ccd6d.svg";